import '../shared/nav/collapsing_nav'
import '../shared/phone'
import '../shared/seating_chart_filter_without_svg'

import AddToCartForms from '../shared/add_to_cart_forms'
import CartNav from '../shared/nav/nav_cart'
import Checkout from '../shared/checkout'
import PackageTabs from '../shared/package_tabs'
import SeatingChart from '../shared/seating_chart_param_feature'

document.addEventListener('turbo:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  Checkout.loadWithAddOn()
  SeatingChart.showPackages()
  PackageTabs.loadTabs(769)
})
